// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/solana-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompressedNftEventMetadata } from './CompressedNftEventMetadata';
import {
    CompressedNftEventMetadataFromJSON,
    CompressedNftEventMetadataFromJSONTyped,
    CompressedNftEventMetadataToJSON,
} from './CompressedNftEventMetadata';
import type { TransactionType } from './TransactionType';
import {
    TransactionTypeFromJSON,
    TransactionTypeFromJSONTyped,
    TransactionTypeToJSON,
} from './TransactionType';

/**
 * 
 * @export
 * @interface CompressedNftEvent
 */
export interface CompressedNftEvent {
    /**
     * 
     * @type {TransactionType}
     * @memberof CompressedNftEvent
     */
    type: TransactionType;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    treeId: string;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftEvent
     */
    leafIndex: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftEvent
     */
    seq: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    assetId: string | null;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftEvent
     */
    instructionIndex: number | null;
    /**
     * 
     * @type {number}
     * @memberof CompressedNftEvent
     */
    innerInstructionIndex: number | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    newLeafOwner: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    oldLeafOwner: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    newLeafDelegate: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    oldLeafDelegate: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompressedNftEvent
     */
    treeDelegate: string | null;
    /**
     * 
     * @type {CompressedNftEventMetadata}
     * @memberof CompressedNftEvent
     */
    metadata: CompressedNftEventMetadata | null;
}

/**
 * Check if a given object implements the CompressedNftEvent interface.
 */
export function instanceOfCompressedNftEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "treeId" in value;
    isInstance = isInstance && "leafIndex" in value;
    isInstance = isInstance && "seq" in value;
    isInstance = isInstance && "assetId" in value;
    isInstance = isInstance && "instructionIndex" in value;
    isInstance = isInstance && "innerInstructionIndex" in value;
    isInstance = isInstance && "newLeafOwner" in value;
    isInstance = isInstance && "oldLeafOwner" in value;
    isInstance = isInstance && "newLeafDelegate" in value;
    isInstance = isInstance && "oldLeafDelegate" in value;
    isInstance = isInstance && "treeDelegate" in value;
    isInstance = isInstance && "metadata" in value;

    return isInstance;
}

export function CompressedNftEventFromJSON(json: any): CompressedNftEvent {
    return CompressedNftEventFromJSONTyped(json, false);
}

export function CompressedNftEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompressedNftEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': TransactionTypeFromJSON(json['type']),
        'treeId': json['treeId'],
        'leafIndex': json['leafIndex'],
        'seq': json['seq'],
        'assetId': json['assetId'],
        'instructionIndex': json['instructionIndex'],
        'innerInstructionIndex': json['innerInstructionIndex'],
        'newLeafOwner': json['newLeafOwner'],
        'oldLeafOwner': json['oldLeafOwner'],
        'newLeafDelegate': json['newLeafDelegate'],
        'oldLeafDelegate': json['oldLeafDelegate'],
        'treeDelegate': json['treeDelegate'],
        'metadata': CompressedNftEventMetadataFromJSON(json['metadata']),
    };
}

export function CompressedNftEventToJSON(value?: CompressedNftEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': TransactionTypeToJSON(value.type),
        'treeId': value.treeId,
        'leafIndex': value.leafIndex,
        'seq': value.seq,
        'assetId': value.assetId,
        'instructionIndex': value.instructionIndex,
        'innerInstructionIndex': value.innerInstructionIndex,
        'newLeafOwner': value.newLeafOwner,
        'oldLeafOwner': value.oldLeafOwner,
        'newLeafDelegate': value.newLeafDelegate,
        'oldLeafDelegate': value.oldLeafDelegate,
        'treeDelegate': value.treeDelegate,
        'metadata': CompressedNftEventMetadataToJSON(value.metadata),
    };
}

